module.exports = __webpack_public_path__ + "img/box-heart.fe82eeb9.svg";